import transformIndexToWorld from './transformIndexToWorld.js';
export function transformIJKToCanvas(viewport, ijkPoint) {
    const { imageData: vtkImageData } = viewport.getImageData();
    const worldPoint = transformIndexToWorld(vtkImageData, ijkPoint);
    return viewport.worldToCanvas(worldPoint);
}
